import { themeName } from '../config/theme-config';
import { loadTheme } from '../theme/ThemeProvider';

export function applyMetaInformation() {
  const theme = loadTheme(themeName);

  const title = document.querySelector('title');
  if (title && theme) {
    title.nodeValue = theme.meta.title;
  }

  const metaDescription = document.querySelector('meta[name="description"]');
  if (metaDescription && theme) {
    metaDescription.setAttribute('content', theme.meta.description);
  }

  const element = document.createElement('link');
  element.setAttribute('rel', 'manifest');
  element.setAttribute('href', theme?.meta.manifestPath || '/loopManifest.json');
  document.querySelector('head')?.appendChild(element);
}
